import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddWoundCareToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/woundCare/store/woundCare.actions'
import { addWoundCareItem } from '../../timeline/store/timeline.actions'
import { WoundCareConstants } from '../../procedures/woundCare/store/woundCare.constants'

export function* saveWoundCareQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addWoundCareToTimeline } = quickActionsObject
  if (addWoundCareToTimeline) {
    yield put(addWoundCareItem())
    yield put(setAddWoundCareToTimeline(false))
    yield put(resetState())
  }
}

export function* saveWoundCareQuickActionTimeLineRowSaga() {
  yield takeLatest([WoundCareConstants.SET_ADD_TO_TIMELINE], saveWoundCareQuickActionTimeLineRow)
}
